// 日语

export default {
  t1: '完了',
  t5: '支払い',
  t6: '連携して認証する',
}
